/** Clinic admin: the lab tests shown on the clinic's public page, and their prices. */
import { fetchApi } from '../client';

export interface LabPriceRow {
  testId: string;
  name: string;
  category?: string | null;
  sampleType?: string | null;
  /** The clinic's price (what patients see and are charged for home collection); null for a candidate. */
  price?: number | null;
  /** The catalogue's base price, for reference. */
  catalogPrice?: number | null;
  platformTest: boolean;
}

export interface LabListStatus { clinicPagePublic: boolean; homeCollectionOffered: boolean; tests: LabPriceRow[] }

const BASE = '/api/clinic/public-lab-tests';

export const publicLabTestsModule = {
  list: () => fetchApi<LabListStatus>(BASE),
  candidates: (q: string) => fetchApi<LabPriceRow[]>(`${BASE}/candidates?q=${encodeURIComponent(q)}`),
  upsert: (testId: string, price: number) =>
    fetchApi<LabPriceRow>(`${BASE}/${encodeURIComponent(testId)}`, { method: 'PUT', body: JSON.stringify({ price }) }),
  remove: (testId: string) => fetchApi<void>(`${BASE}/${encodeURIComponent(testId)}`, { method: 'DELETE' }),
};
